import React, { useState } from "react";

// libraries
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

// components
import colors from "core/colors";
import OffsetGrid from "core/OffsetGrid";
import SectionContainer from "core/SectionContainer";
import BodyText from "core/BodyText";
import LoadingSpinner from "core/LoadingSpinner";
import breakpoints from "core/breakpoints";
import CheckoutHeader from "subscriptions/components/CheckoutHeader";
import Form from "./Form";

// helpers
import { useViewport } from "js/hooks/useViewport";

// styles
import { TeamInfoContainer, CheckoutPageHeading } from "subscriptions/styles";
import { initialForm } from "subscriptions/data";

const stripePromise = loadStripe(window._nounConfig.stripePublishable);

const NounProTeamCheckout = ({ match }) => {
    const { planType, teamName, numSeats, teamUser } = match.params;
    const { browserWidth } = useViewport();
    const [form, setForm] = useState(initialForm);

    return (
        <SectionContainer
            bgColor={colors.secondary.orca}
            removeLeftRightPadding={browserWidth < breakpoints.beforeTablet.px}
        >
            <CheckoutPageHeading
                type="h1"
                size="xl"
                headingColor={colors.primary.diamond}
                alignment="center"
                topSpacing="none"
                bottomSpacing="4xl"
            >
                Start Your NounTeam Subscription
            </CheckoutPageHeading>
            <OffsetGrid sm={12} md={12} lg={8}>
                <SectionContainer
                    bgColor={colors.primary.snow}
                    topSpacing="2xl"
                    bottomSpacing="2xl"
                >
                    <OffsetGrid sm={12} md={8} lg={6}>
                        <TeamInfoContainer>
                            <CheckoutHeader />

                            <BodyText size="md">Team: {teamName}</BodyText>
                            <BodyText size="md">Members: {numSeats}</BodyText>
                        </TeamInfoContainer>

                        <Elements stripe={stripePromise}>
                            <Form
                                showOrderSummary={false}
                                setForm={setForm}
                                form={form}
                                planType={planType}
                                teamName={teamName}
                                numSeats={numSeats}
                                teamUser={teamUser}
                            />
                        </Elements>
                    </OffsetGrid>
                </SectionContainer>
            </OffsetGrid>
        </SectionContainer>
    );
};

export default NounProTeamCheckout;
